<h1 class="mt-5">Configuración carga de calificaciones</h1>

<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Ingreso de archivo</h6>
</div>

<div *ngIf="alertaExitosa !== ''" class="alert alert-success tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert">
	<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i> {{ alertaExitosa }}
</div>

<div *ngIf="error !== ''" class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert">
  <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ error }}
</div>

<form class="form" [formGroup]="parametrosForm">
	<div class="row mt-5 align-items-end">
		<div class="col-4">
			<label class="titulo_criterios" style="display: initial;" for="exampleFormControlSelect2">Cargar archivo ( peso máx: 1mb)  </label>
      <button (click)="descargarEjemplo()" class="btn py-0" data-toggle="tooltip" data-placement="top" title="Descargar archivo ejemplo" alt="Descargar archivo ejemplo" type="button">
        <i class="bi bi-filetype-xlsx icono-tabla"></i>
      </button>
      <div class="custom-file">
        <input [id]="'file-0'" class="d-none" (change)="onFileChanged($event, 0);resetearValidacion()" onclick="this.value=null;" type="file" class="custom-file-input" [ngClass]="{ 'is-invalid': submitted && tieneErrores['archivo'] }" required>
        <label class="custom-file-label select_criterios mb-0" for="validatedCustomFile">{{textoCargaArchivo}}
        </label>
        <div *ngIf="submitted && tieneErrores['archivo']" class="invalid-feedback position-absolute">
          <div *ngIf="tieneErrores['archivo']">Campo requerido</div>
        </div>
      </div>
		</div>
		<div class="col-2 centrar_iconos_botones">
			<button (click)="procesar()" class="boton-primario" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR">
        Procesar
      </button>
		</div>
		<div (click)="limpiarCargaArchivo()" class="col-1 centrar_iconos_botones">
			<button class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
		</div>
	</div>
</form>

<!-- TABLA -->
<div style="margin-top: 34px;" class="pb-3">
	<table *ngIf="renderTable" datatable [dtOptions]="dtOptions" class="row-border hover table-striped display nowrap " aria-describedby="tabla reemplazo docente">
		<thead class="header_tabla">
			<tr>
				<th class="py-2">Id Proceso</th>
				<th class="py-2">Origen</th>
				<th class="py-2">Registros OK</th>
				<th class="py-2">Registros Error</th>
				<th class="py-2">Estado de carga</th>
				<th class="py-2">Log de errores</th>
				<th class="py-2">Fecha de carga</th>
				<th class="py-2">Usuario de carga</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let archivo of listaArchivos; index as indexArchivo">
				<td class="py-2">{{ archivo.idCarga }}</td>
				<td class="py-2">{{ archivo.origen }}</td>
				<td class="py-2">{{ archivo.nroRegOk }}</td>
				<td class="py-2">{{ archivo.nroRegError }}</td>
				<td class="py-2">
					<span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="archivo.estado == 'F'">Finalizado</span>
					<span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="archivo.estado == 'EP'">En proceso</span>
					<span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="archivo.estado == 'ER'">Error</span>
				</td>
				<td class="py-2">
					<div class="d-flex justify-content-center align-items-center"  *ngIf="archivo.estado == 'F'">
						<div>
							<button (click)="obtenerLog(archivo.idCarga)" *ngIf="archivo.nroRegError !== 0"  class="btn p-0" data-toggle="tooltip" data-placement="top" title="DESCARGAR REPORTE EXCEL" alt="DESCARGAR REPORTE EXCEL">
								<i class="bi bi-filetype-xlsx icono-tabla"></i>
							</button>
							<i class="bi bi-dash" *ngIf="archivo.nroRegError == 0"></i>
						</div>
					</div>
				</td>
				<td class="py-2">{{ archivo.fechaCreacion }}</td>
				<td class="py-2">{{ archivo.usuarioCreacion }}</td>
			</tr>
		</tbody>
	</table>
</div>
<!-- FIN TABLA -->

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>
